// Called by custom/init-form.js
function initFormValidation(){
  var contactForm = jQuery('#contact-form');
  if (contactForm) {
    if (typeof contactForm.validationEngine == 'function') { 
      contactForm.validationEngine();
    }
  }

  var leadForm = jQuery('#lead-form');
  if (leadForm) {
    if (typeof leadForm.validationEngine == 'function') { 
      leadForm.validationEngine();
    }
  }

  jQuery(".form-submit").on('click', function(e) {
    jQuery(this).prop('disabled', true);

    var email = jQuery("input[name='Email']").val()
    if ( typeof email != 'undefined' ) { 
      email = email.toLowerCase();
    }

    if ( 
      typeof email != 'undefined'
      && (
        email.indexOf("q?=user") > -1 
        || email.indexOf("wp-login") > -1 
        || email.indexOf("http") > -1 
        || email.indexOf("www.") > -1 
        || email.indexOf("/") > -1 
        || email.indexOf(".ru ") !== -1 
      )
    ) {
        jQuery(".wpcf7-response-output").removeClass("hide").text("Emails from the extension .ru and links are not allowed.  Please change it and resubmit.");
        jQuery("input[name='Email']").focus();
        jQuery(this).prop('disabled', false);
        e.preventDefault();
        return false;
    } else {
        jQuery(".wpcf7-response-output").addClass("hide");
    }

    var comments = jQuery("[name='r_comments']").val();
    if ( typeof comments != 'undefined' ) { 
      comments = comments.toLowerCase();
    }

    if (
      typeof comments != 'undefined'
      && (
        comments.indexOf("q?=user") > -1 
        || comments.indexOf("wp-login") > -1
        || comments.indexOf("http") > -1
        || comments.indexOf("www.") > -1
        || comments.indexOf(".ru ") !== -1
      ) 
    ) {
      jQuery(".wpcf7-response-output").removeClass("hide").text("Your comments field may contain a link.  Please remove the link and try again, thanks!");
      jQuery("[name='r_comments']").focus();
      jQuery(this).prop('disabled', false);
      e.preventDefault();
      return false;
    } else {
      jQuery(".wpcf7-response-output").addClass("hide");
    }

    jQuery(this).prop('disabled', false);
  });
}